import { v4 as uuidv4 } from "uuid"; // Install uuid library using `npm install uuid`

export function generateUniqueSku(): string {
  // Use a UUID to ensure global uniqueness
  const uniqueId = uuidv4().split("-")[0]; // Shorten UUID if needed
  return `SKU${uniqueId.toUpperCase()}`; // Prefix with SKU
}
// Output: e.g., SKU5D414D
